import { HttpErrorName, HttpStatusCode } from '../constants';

export const ERROR_NAMES_MAP: Partial<Record<HttpStatusCode, HttpErrorName>> = {
  [HttpStatusCode.BadRequest]: HttpErrorName.BadRequest,
  [HttpStatusCode.Unauthorized]: HttpErrorName.Unauthorized,
  [HttpStatusCode.Forbidden]: HttpErrorName.Forbidden,
  [HttpStatusCode.NotFound]: HttpErrorName.NotFound,
  [HttpStatusCode.Unknown]: HttpErrorName.Unknown,
};
